import { closeProjectCellModal } from '../State/projectCellModal'
import fetch from '../Services/fetch'
import fetchMapData from '../Handlers/fetchMapData'

export default (reload = false) => (dispatch, getState) => {

  dispatch(closeProjectCellModal())

  if (reload) {
    const { controls } = getState().screens.Planner
    
    if (controls.yAxis === 'map') {
      dispatch(fetchMapData({ silent: true }))
    } else {
      // Refresh planner data
      dispatch(fetch())
    }
  }

}
